/**
 * Registry of how much data the mounted collection view has loaded, summed
 * across the view's data sources — grouped views run one query per group, and
 * panes like Unscheduled or expanded tree rows add their own — so long-task
 * reports can carry the view's real scale rather than one group's slice.
 *
 * Kept free of React and Sentry imports: sources are written from a hook,
 * read back by MBSentry when it builds or updates the collection view context.
 */

export interface CollectionViewScaleCounts {
  loadedEntityCount: number;
  totalEntityCount: number;
}

const sources = new Map<symbol, CollectionViewScaleCounts>();

export function setCollectionViewScaleSource(
  handle: symbol,
  counts: CollectionViewScaleCounts,
): void {
  sources.set(handle, counts);
}

export function removeCollectionViewScaleSource(handle: symbol): void {
  sources.delete(handle);
}

export function getCollectionViewScaleAggregate(): CollectionViewScaleCounts | undefined {
  if (sources.size === 0) {
    return undefined;
  }
  let loadedEntityCount = 0;
  let totalEntityCount = 0;
  for (const counts of sources.values()) {
    loadedEntityCount += counts.loadedEntityCount;
    totalEntityCount += counts.totalEntityCount;
  }
  return { loadedEntityCount, totalEntityCount };
}
